const BaseDirectives = {
};

export default BaseDirectives;
